import styled from 'styled-components';
import { Scrollable, colorVars, sizeVars } from '@routific/hive/v5';

export const ContentScroll = styled(Scrollable)`
  flex: 1 1 auto;
  min-height: 0;
  height: 100%;
`;

export const MapContainer = styled.div`
  position: relative;
  flex: 0 0 auto;
  height: 140px;
  width: 100%;
  overflow: hidden;
  /* Parent border sits outside the map canvas stacking context (MapBase is z-index: 1). */
  border-bottom: ${sizeVars.stroke.hairline} solid ${colorVars.border.neutral.default};
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizeVars.space[100]};
  padding: ${sizeVars.space[100]} ${sizeVars.space[200]};
`;

export const InlineRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizeVars.space[50]};
`;

export const InlineWarning = styled.div`
  display: flex;
  align-items: flex-start;
  gap: ${sizeVars.space[50]};
  margin-top: ${sizeVars.space[50]};
`;
